import { Button as MuiButton, ButtonProps } from '@mui/material';
import cls from 'classnames';
import styles from './m-button.module.scss';
const MButton = (props: ButtonProps) => {
    const {sx, ...rest} = props;
    return <MuiButton
        className={cls(styles.mButton, styles.fancy)}
        sx={{
        width: {
            xs: '100%',
            lg: '352px',
        },
        ...sx
    }} {...rest} />;
}

export {
    MButton
}